import { Image } from '#app/components/Image/Image.js';
import { Theme } from '#app/theme/index.js';
import { type AvatarImageProps } from './types.js';
import { getAvatarSize } from './utils.js';
import { styled } from 'styled-components';

const AvatarContainer = styled(Image)<{
  $borderColor?: keyof Theme['colorsV2'];
}>`
  ${({ $borderColor, theme }) => `
    position: relative;
    border-radius: 50%;
    border: ${
      $borderColor ? `1px solid ${theme.colorsV2[$borderColor]}` : 'none'
    };
    margin: 0;
    display: block;
    transition: all 350ms ease;
    transition-property: width, height, border;
    background-color: white;
  `}
`;

const AvatarContainerWrapper = styled.div`
  display: flex;
  position: relative;
  width: fit-content;
  height: fit-content;
`;

const WhiteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1;
  border-radius: 50%;
  &:hover {
    background: none;
  }
`;

const OverflowContainer = styled.div`
  padding: 0;
  div {
    overflow: unset;
  }
`;

export const AvatarImage = ({
  alt,
  avatarImage,
  avatarRef,
  borderColor,
  deactivated,
  onClick,
  previewImage,
  size = 'xs',
  ...props
}: AvatarImageProps) => {
  const computedSize = getAvatarSize(size);
  if (previewImage) {
    return (
      <OverflowContainer>
        <AvatarContainerWrapper>
          {deactivated ? <WhiteOverlay /> : null}
          <AvatarContainer
            $borderColor={borderColor}
            alt={alt}
            aria-label="avatar preview"
            grayscale={deactivated}
            height={computedSize}
            layout="fixed"
            onClick={onClick}
            ref={avatarRef}
            src={previewImage}
            width={computedSize}
            {...props}
          />
        </AvatarContainerWrapper>
      </OverflowContainer>
    );
  } else if (avatarImage) {
    return (
      <OverflowContainer>
        <AvatarContainerWrapper>
          {deactivated ? <WhiteOverlay /> : null}
          <AvatarContainer
            $borderColor={borderColor}
            alt={alt}
            grayscale={deactivated}
            height={computedSize}
            id={avatarImage.id}
            layout="fixed"
            onClick={onClick}
            ref={avatarRef}
            uid={avatarImage.uid}
            width={computedSize}
            {...props}
          />
        </AvatarContainerWrapper>
      </OverflowContainer>
    );
  } else {
    return null;
  }
};
